import React from "react";
import { PhoneFilled, BranchesOutlined } from "@ant-design/icons"; // Import any icons you prefer
import { Button } from "antd";

import ICON from "../assets/icon.jpg";

const MiddleBar = () => {
  return (
    <div className="text-white py-2 px-4 flex justify-between  i text-sm">
      {/* Logo Section */}
      <div className="flex items-center space-x-2">
        <img src={ICON} alt="Logo" className="h-24" /> <span className="text-black font-bold text-2xl md:text-4xl"><span className="text-pink-600">Future</span>  Skill</span>
      </div>
      <div className="flex  ">
        <div className="flex items-center space-x-2 ">
          <Button
            type="primary"
            icon={<PhoneFilled className="" />}
            className="bg-blue-500 hover:bg-blue-600"
          >
            Call Now
          </Button>
        </div>

        {/* Total Branches */}
        
      </div>
    </div>
  );
};

export default MiddleBar;
